jQuery.fn.selectText = function(){
   var doc = document;
   var element = this[0];
   var range, selection;
   // console.log(this, element);
   if (doc.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
   } else if (window.getSelection) {
        selection = window.getSelection();      
        range = document.createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
   }
};

// opening sidebar
$('body').on('click', '.open-sidebar', function() {
    $('.sidebar').addClass('sidebar-open');
    $('.sidebar-overlay').addClass('sidebar-open');
    $('body').addClass('sidebar-open');
    return false;
});

$('body').on('click', '.close-sidebar', function() {
    $('.sidebar').removeClass('sidebar-open');
    $('.sidebar-overlay').removeClass('sidebar-open');
    $('body').removeClass('sidebar-open');
    return false;
});

// include the close modal functions
function closeModal() {
	$('.overlay, .modal').removeClass('visible');
}

function openModal(modal) {
	
	var scrollTop = $(window).scrollTop();
	$(modal).css({
		'top': (scrollTop-500)+'px'
	});
	
	setTimeout(function() {
		$(modal).addClass('visible');
		$(modal).find('.fields li input, .fields li textarea').each(function() {
			var $this = $(this);
			if($this.val() !== '') {
				$this.parent('li').addClass('filled');
			} else {
				$this.parent('li').removeClass('filled');
			}
		});
	}, 100);

	$('.overlay').addClass('visible');
}


$('body').click(function(e){
    if($(e.target).attr('class') === 'overlay visible') {
        closeModal();
    }
});

$(document).keyup(function(e) {
    if (e.keyCode === 27) { // Esc
        closeModal();
    }
});

$('body').on('click', '.modal a.close', function() {
    closeModal();        
    return false;
});

$('body').on('click', '.modal a.close-error', function() {
	if($('.modal.visible').length === 1) {
		$('.display-error, .overlay').removeClass('visible');
	} else {
		$('.display-error').removeClass('visible');
	}
  	
    return false;
});

function showError(header, message, button) {
	button = typeof button === 'undefined' ? 'Close' : button;

	var scrollTop = $(window).scrollTop();
	$('.display-error').css({
		'top': (scrollTop-500)+'px'
	});


	$('.display-error h6').html(header);
	$('.display-error .error-message').html(message);
	$('.display-error .button').html(button);
	$('.overlay, .modal.display-error').addClass('visible');
}


// add the filled class to the labels
$('body').on('focus', '.fields li input, .fields li textarea', function() {
	var $this = $(this);
	$this.keyup(function() {
		if($this.val() !== '') {
			$this.parent('li').addClass('filled');
		} else {
			$this.parent('li').removeClass('filled');
		}
	});
});

$('body').on('keyup blur', '.input input', function() {
    var $this = $(this);
	if($this.val() !== '') {
		$this.parent('.input').addClass('filled');
	} else {
		$this.parent('.input').removeClass('filled');
	}
});

$('body').on('blur', '.fields li input, .fields li textarea', function() {
	var $this = $(this);
	if($this.val() !== '') {
		$this.parent('li').addClass('filled');
	} else {
		$this.parent('li').removeClass('filled');
	}
});

// loading
function loading(message) {
	message = typeof message === 'undefined' ? 'Processing...' : message;
	$('.loading span').html(message);
	$('.loading-overlay, .loading').show();
}

function unloading() {
	$('.loading-overlay, .loading').hide();
}

$('body').on('click', '.loading .hide-loading', function () {
	unloading();
	return false;
});

// toggle card
$('body').on('click', '.toggle-closeable', function() {
    var card = $(this).parents('.card');

    if(card.attr('data-mode') === 'closed') {
    	card.attr('data-mode', 'opened');

    	$('html, body').animate({
    		scrollTop: card.offset().top - 140
    	}, 300);
    } else {
    	card.attr('data-mode', 'closed');
    }
    
    return false;
});

function toggleCardView(card, view) { 
    card.find('footer').hide();
    card.find('.card-details').hide();
    card.find('.parent').hide();

    card.find('.parent[data-parent="'+view+'"]').show().css('display', 'flex');
    card.find('footer[data-view="'+view+'"]').show();
    card.find('.card-details[data-view="'+view+'"]').show();

    $('html, body').animate({
        scrollTop: card.offset().top - 140
    }, 300);
}

$('body').on('click', '.toggle-card-view', function() {
    var $this = $(this);
    var card = $this.parents('.card');
    toggleCardView(card, $this.attr('data-view'));
    
    return false;
});

// mask
$('.mask').each(function() {
    var $this = $(this);
    $this.mask($this.attr('data-mask'), {
        placeholder: $this.attr('data-placeholder')
    });
});

function buttons(data) {
    // console.log(data);
	var buttons = '';
	$.each(data, function (index, button) {
		buttons += `<li>
            <a href="${button.href}" class="${button.class}" target="${button.target}">
                <span class="${button.icon} icon" data-color="${button.color}"></span>
                ${button.label}
            </a>
        </li>`;
	});

	return buttons;
}

// function nl2br(str = null) {
// 	return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br>' + '$2');
// }

$('body').on('click', '.filters .open-dropdown', function() {
    var $this = $(this);
    var menu = $this.parents('.dropdown-wrapper');

    if (menu.hasClass('opened')) {
        closeDropdown();
        return false;
    }

    menu.addClass('opened');
    closeDropdown($this.parents('.dropdown-wrapper').attr('data-dropdown'));
    return false;
});